import React from "react";
import { modalBoxStyle } from "./styles";
import { Button, Typography, Box, Modal } from "@mui/material";

const LiveEditErrorModal = ({
  isOpen,
  headerText,
  bodyText,
  buttonText,
  toggleErrorModalOpen,
}) => (
  <Modal
    open={isOpen}
    onClose={() => toggleErrorModalOpen(false)}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
    style={{ marginTop: "2em" }}
  >
    <Box sx={modalBoxStyle}>
      <Typography style={{ fontSize: "2rem", marginBottom: "1rem" }}>
        {headerText}
      </Typography>
      <Typography style={{ fontSize: "1rem", marginBottom: "1rem" }}>
        {bodyText}
      </Typography>
      <div style={{ border: "solid", borderWidth: "thin" }} />
      <div style={{ display: "flex", marginTop: "1rem" }}>
        <Button
          variant="contained"
          type="submit"
          style={{ marginLeft: "1rem" }}
          onClick={() => window.location.reload()}
        >
          {buttonText}
        </Button>
      </div>
    </Box>
  </Modal>
);

export default LiveEditErrorModal;
